<template>
  <div>
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                  <v-text-field
                    label="Buscar"
                    class="border-container"
                    prepend-inner-icon="search"
                    clearable
                    solo
                    flat
                    hide-details
                    v-model="filters.search"
                    @keyup.enter="getItems"
                    @click:clear="clearSearch"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text class="px-0 py-0">
              <v-data-table
                :rows-per-page-items="[25, 50, 100]"
                rows-per-page-text="Registros por página"
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :loading="isLoadingTable"
                no-results-text="No se encontraron coincidencias"
                no-data-text="No hay registros"
                :pagination.sync="pagination"
                @update:pagination="getItems"
              >
                <template v-slot:headers="props">
                  <tr>
                    <td v-for="header in props.headers" :style="header.style">
                      {{ header.text }}
                    </td>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr class="body-2 font-weight-regular">
                    <td>
                      <v-avatar
                        :tile="false"
                        size="30"
                        color="grey lighten-4"
                        v-if="
                          props.item.imageStorage &&
                          props.item.imageStorage.miniObjUrl
                        "
                      >
                        <img
                          :src="props.item.imageStorage.miniObjUrl"
                          alt="avatar"
                        />
                      </v-avatar>
                      <v-avatar v-else text-color="white">
                        <v-icon>account_circle</v-icon>
                      </v-avatar>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{ props.item.name }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      {{
                        props.item.roundType === 'EVENTUAL'
                          ? 'Eventual'
                          : 'Permanente'
                      }}
                    </td>
                    <td>{{ parseUiTime(props.item.createdAt) }}</td>
                    <td>{{ parseUiTime(props.item.expDate) }}</td>

                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click="detail(props.item)" icon v-on="on">
                            <v-icon class="gray--text">visibility</v-icon>
                          </v-btn>
                        </template>
                        <span>Ver detalle</span>
                      </v-tooltip>
                    </td>
                    <td>
                      <DropDownOptions>
                        <v-list>
                          <v-list-tile @click="editRound(props.item.id)">
                            <v-list-tile-action>
                              <v-icon>edit</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title> Editar </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-divider></v-divider>
                          <v-list-tile @click="deletRound(props.item.id)">
                            <v-list-tile-action>
                              <v-icon>delete</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title> Eliminar </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </DropDownOptions>
                    </td>
                  </tr>
                </template>
                <v-progress-linear
                  v-slot:progress
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <template v-slot:no-data>
                  <div>No hay registros para filtrar</div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <ConfirmDelete
      :show="modals.showDelete"
      title="¿Estas seguro que deseas eliminar la ronda?"
      cancel-text="No, Cancelar"
      ok-text="Sí, Eliminar"
      @change="onConfirmDelete"
    >
      <p>Al eliminarla, los alumnos ya no pertenecerán a esta ronda</p>
    </ConfirmDelete>
    <Success v-model="modals.showSuccess" :text="modals.successMessage" />
    <Error v-model="modals.showError" :text="modals.errorMessage" />
    <Loading v-model="modals.deleteResponseLoading" />
  </div>
</template>
<script>
import moment from 'moment'
import Error from '../../../../Dialogs/Error.vue'
import Loading from '../../../../Dialogs/Loading.vue'
import Success from '../../../../Dialogs/Success.vue'
import ConfirmDelete from '../../../../Dialogs/confirm_new_ui.vue'
import DropDownOptions from '../../../../dropDown/options.vue'

export default {
  components: {
    ConfirmDelete,
    DropDownOptions,
    Success,
    Loading,
    Error,
  },
  data: () => ({
    modals: {
      showDelete: false,
      deleteResponseLoading: false,
      deleteId: undefined,
      showSuccess: false,
      successMessage: false,
      showError: false,
      errorMessage: false,
    },
    filters: { search: '' },
    showFilter: false,
    headers: [
      {
        text: 'Foto',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Nombre',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Tipo',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Fecha de creación',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Fecha autorizada',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Ver detalle',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Acción',
        sortable: false,
        align: 'center',
      },
    ],
    totalItems: 0,
    pagination: {
      page: 1,
      rowsPerPage: 25,
    },
    items: [],
    isLoadingTable: false,
  }),
  methods: {
    async getItems() {
      const params = {
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        size: this.pagination.rowsPerPage,
        search: this.filters.search === '' ? undefined : this.filters.search,
      }
      this.$emit('params', params)
      this.isLoadingTable = true

      try {
        const { data } = await this.$store.dispatch(
          'round/getCollegeRounds',
          params
        )

        this.items = data.data
        this.totalItems = data.total
      } catch (error) {
        console.log(error)
        this.items = []
        this.totalItems = 0
      } finally {
        this.isLoadingTable = false
      }
    },
    clearSearch() {
      this.filters.search = ''
      this.getItems()
    },
    detail(item) {
      this.$router.push({
        name: 'detailRound',
        params: { id: item.id },
      })
    },
    editRound(itemId) {
      this.$router.push({
        name: 'editCollegeRound',
        params: { id: itemId },
      })
    },
    deletRound(itemId) {
      this.modals.deleteId = itemId
      this.modals.showDelete = true
    },
    async onConfirmDelete(e) {
      this.modals.showDelete = false
      if (e === false) return
      this.modals.deleteResponseLoading = true
      try {
        await this.$store.dispatch(
          'round/deleteCollegeRound',
          this.modals.deleteId
        )

        this.modals.showSuccess = true
        this.modals.successMessage = 'Ronda eliminada con éxito.'
      } catch (error) {
        console.log(error)
        const customErrors = {
          404: 'No se encontró la ronda.',
          400: 'La ronda que se pretende eliminar no pertenece al colegio.',
        }

        this.modals.showError = true
        this.modals.errorMessage = customErrors[error.response.status]
          ? customErrors[error.response.status]
          : 'Error al eliminar ronda'
      } finally {
        this.modals.deleteResponseLoading = false
        this.modals.deleteId = undefined
        this.getItems()
      }
    },
    parseStartUiTime(time) {
      return this._timeParseCapitalize(this._parseTime(time))
    },
    parseUiTime(time) {
      if (time === undefined) {
        return 'Indefinido'
      }

      return this._timeParseCapitalize(this._parseTime(time))
    },
    _timeParseCapitalize(time = '') {
      const [day, month, year] = time.split('/')
      const capitalMonth = `${month
        .substring(0, 1)
        .toUpperCase()}${month.substring(1)}`

      return `${day}/${capitalMonth}/${year}`
    },
    /**
     * Return a date like so `24/jul/2023 `
     */
    _parseTime(date) {
      return moment(new Date(date)).format('DD/MMM/YYYY').replaceAll('.', '')
    },
  },
}
</script>

<style scoped>
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}
::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  background-color: #f9fafb;
  height: 40px;
}
::v-deep .v-datatable.v-table > thead tr {
  background-color: #dddddd;
  text-transform: initial !important;
  color: #6b7280;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
}

::v-deep .v-datatable.v-table > tbody {
  max-height: 50vh;
}
::v-deep .v-datatable.v-table > tbody tr td {
  text-align: center;
  font-size: inherit;
  font-weight: inherit;
}
::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
